import { useSelector } from 'react-redux';

import { useGetCurrentUser } from '@wecasa/auth/src/authentication-context';

import type { Booking } from '@wecasa/common/src/types/customer';

import { getIsMembershipRequested, getMode, getModifiedBooking } from '@wecasa/customer/src/ducks/basket-selectors';
import type { BasketMode } from '@wecasa/customer/src/types/basket';

import { hasMembership } from '../utils/membership';

const modificationModes: BasketMode[] = ['modifyPrestations', 'modifyAppointment', 'modification'];

// NOTE: this hook should currently only be used in a web context, because of the different auth
// handling with `useGetCurrentUser` (see @wecasa/auth). Mobile resolves the current user differently.
const useHasOrWantsMembership = () => {
  const user = useGetCurrentUser();
  const isMembershipRequested: boolean | undefined = useSelector(getIsMembershipRequested);
  const modifiedBooking: Booking | undefined = useSelector(getModifiedBooking);
  const mode: BasketMode | null = useSelector(getMode);

  // In modification mode, we show membership prices if the booking has been created during
  // active or requested membership.
  // Like this customers have correct prices when modifying a membership booking, even if their
  // user membership status changed.
  if (mode && modificationModes.includes(mode) && modifiedBooking) {
    return !!modifiedBooking.has_membership;
  }

  // During creation user is either already member or the paywall got validated
  return hasMembership(user) || !!isMembershipRequested;
};

export default useHasOrWantsMembership;
